import Common, { ServiceOptions } from "./Common";
import Rest from "./Rest";

/**
 * AIチャットボットの貼り付けURLを取得します。 
 * @param accessToken {string} アクセストークン.
 * @param signal {AbortSignal} 中断シグナル.
 * @returns {string} 貼り付けURL.
 */
const getUrl = async (accessToken: string, signal?: AbortSignal): Promise<string> => {
    const data = await Rest.get<string>({
        url: "/api/ai/chatbots",
        authorization: accessToken,
        signal: signal,
    }) as string;
    return data;
};

/** AIチャットボット設定 */
export type ChatbotSetting = {
    /** サポートされているかを判定する値 */
    supported: boolean;
    /** 貼り付けURL */
    url: string;
};

/**
 * AIチャットボットの設定を取得します。 
 * @param accessToken {string} アクセストークン.
 * @param officeId {number} 事業所ID
 * @param signal {AbortSignal} 中断シグナル.
 * @returns {ChatbotSetting} 設定.
 */
const getSetting = async (accessToken: string, officeId: number, signal?: AbortSignal): Promise<ChatbotSetting> => {
    return ({
        supported: await Common.getAvailableOption(accessToken, officeId, ServiceOptions.aiAnalyze, signal),
        url: await getUrl(accessToken, signal),
    });
};

/** AIチャットボット関連API */
export const Chatbot = {
    getSetting,
} as const;